<template>
  <v-app>
    <v-slide-x-transition>
      <component
        @selected="changeSelection"
        :is="currentComponent"
        v-if="currentComponent"
      />
    </v-slide-x-transition>
  </v-app>
</template>

<script>
import ModuleSelection from "@/components/connect/ModuleSelection.vue";
import Customer from "@/views/PitchConnect/customer/Customer.vue";
import Partner from "@/views/PitchConnect/partner/Partner.vue";

export default {
  name: "LoginPage",
  components: { ModuleSelection, Customer, Partner },
  methods: {
    changeSelection(value) {
      this.currentComponent = value;
    },
  },
  data() {
    return {
      defaultComponent: "ModuleSelection",
      currentComponent: "ModuleSelection",
    };
  },
};
</script>

<style scoped></style>
